// src/components/LogoutConfirmModal.js
import React from 'react';
import './LogoutConfirmModal.css';

const LogoutConfirmModal = ({ currentLanguage, getLocalizedText, onConfirm, onCancel }) => {
  const t = (ar, en) => getLocalizedText(ar, en);

  return (
    <div className="logout-confirm-overlay">
      <div className={`logout-confirm-modal ${currentLanguage === 'ar' ? 'ar' : 'en'}`}>
        <h3 className="logout-confirm-title">
          {t('هل أنت متأكد؟', 'Are you sure?')}
        </h3>
        <p className="logout-confirm-message">
          {t('هل تريد حقًا تسجيل الخروج من حسابك؟', 'Do you really want to log out of your account?')}
        </p>

        <div className="logout-confirm-buttons">
          <button className="logout-confirm-btn cancel" onClick={onCancel}>
            {t('إلغاء', 'Cancel')}
          </button>
          <button className="logout-confirm-btn confirm" onClick={onConfirm}>
            {t('نعم، تسجيل الخروج', 'Yes, Logout')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmModal;